import { render, staticRenderFns } from "./CodeView.vue?vue&type=template&id=18970a64&"
import script from "./CodeView.vue?vue&type=script&lang=ts&"
export * from "./CodeView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('18970a64', component.options)
    } else {
      api.reload('18970a64', component.options)
    }
    module.hot.accept("./CodeView.vue?vue&type=template&id=18970a64&", function () {
      api.rerender('18970a64', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/reusable/CodeView/CodeView.vue"
export default component.exports